import { gql } from '../../../../../hooks'

export const READ_BRANDS = gql`
  query AdministrationReadComponentBrands($id: ID!) {
    aRead(path: "component/brands", id: $id) {
    }
  }
`

export const UPDATE_BRANDS = gql`
  mutation AdministrationUpdateComponentBrands($id: ID!, $data: JSONObject) {
    aUpdate(path: "component/brands", id: $id, data: $data) {
    }
  }
`

export const CREATE_BRANDS = gql`
  mutation AdministrationCreateComponentBrands($data: JSONObject) {
    aCreate(path: "component/brands", data: $data) {
    }
  }
`

export const LIST_BRANDS = gql`
  query AdministrationListComponentBrands(
    $page: Int
    $limit: Int
    $filter: JSONObject
  ) {
    aList(
      path: "component/brands"
      filter: $filter
      page: $page
      limit: $limit
    ) {
      pagination {
        page
        limit
        number_of_pages
      }
    }
  }
`
